module.exports = __webpack_public_path__ + "img/class-bluk-banner-jp.fe3a11a.png";